import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_SLOTS_LIST_GET',
  GET_SUCCESS: 'STUDENT_SLOTS_LIST_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_SLOTS_LIST_GET_FAILURE',

  INVALIDATE_ITEM: 'STUDENT_SLOTS_INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentId, query, meta) =>
    `${BASE_URL}/students/${studentId}/slots/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
